import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { CreateClient } from "./CreateClient";
import {
  HomeownerClientDetail,
  HomeownerClientsList,
  OrganisationClientDetail,
  OrganisationClientsList,
} from "./ClientProfiles";

export default function Clients() {
  return (
    <Switch>
      <Route path="/clients/create">
        <CreateClient />
      </Route>
      <Route path="/clients/homeowners/:id">
        <HomeownerClientDetail />
      </Route>
      <Route path="/clients/homeowners">
        <HomeownerClientsList />
      </Route>
      <Route path="/clients/organisations/:id">
        <OrganisationClientDetail />
      </Route>
      <Route path="/clients/organisations">
        <OrganisationClientsList />
      </Route>
      <Route exact path="/clients">
        <Redirect to="/clients/homeowners" />
      </Route>
    </Switch>
  );
}
